import { useEffect } from "react";
import InputField from "../../../components/InputField";
import SelectField from "../../../components/SelectField";
import Toggle from "../../../components/Toggle";

export default function ImobilStep({ data, errors, update, toggleField }) {
  const ascundeCamere = data.imobilTip === "spatiu_comercial" || data.imobilTip === "altul";

  // Reset numar camere cand se schimba tipul imobilului
  useEffect(() => {
    if (data.imobilCamere) {
      update("imobilCamere")("");
    }
  }, [data.imobilTip]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div style={{ display: "flex", flexWrap: "wrap", gap: "16px" }}>
      <SelectField
        label="Tip imobil"
        value={data.imobilTip}
        onChange={update("imobilTip")}
        options={[
          { value: "apartament", label: "Apartament" },
          { value: "casa", label: "Casa" },
          { value: "spatiu_comercial", label: "Spatiu comercial" },
          { value: "altul", label: "Altul" },
        ]}
        half
      />
      {data.imobilTip === "altul" && (
        <InputField
          label="Specificati tipul imobilului"
          value={data.imobilTipAltul}
          onChange={update("imobilTipAltul")}
          placeholder="ex: garaj, anexa, hala, curte"
          required
          half
          error={errors.imobilTipAltul}
        />
      )}
      <InputField label="Adresa completa a imobilului" value={data.imobilAdresa} onChange={update("imobilAdresa")} placeholder="ex: Str. Victoriei nr. 10, ap. 5, Cluj-Napoca" required error={errors.imobilAdresa} />
      <InputField label="Suprafata utila (mp)" value={data.imobilSuprafata} onChange={update("imobilSuprafata")} placeholder="ex: 55" type="number" required half error={errors.imobilSuprafata} />
      {!ascundeCamere && (
        <SelectField
          label={data.imobilTip === "casa" ? "Numar camere (optional)" : "Numar camere"}
          value={data.imobilCamere}
          onChange={update("imobilCamere")}
          placeholder="Selecteaza numarul de camere"
          options={[
            { value: "1", label: data.imobilTip === "apartament" ? "1 camera (garsoniera)" : "1 camera" },
            { value: "2", label: "2 camere" },
            { value: "3", label: "3 camere" },
            { value: "4", label: "4 camere" },
            { value: "5+", label: "5+ camere" },
          ]}
          half
          required={data.imobilTip === "apartament"}
          error={errors.imobilCamere}
        />
      )}
      <InputField label="Etaj (optional)" value={data.imobilEtaj} onChange={update("imobilEtaj")} placeholder="ex: 3" half />
      <InputField label="Nr. maxim persoane" value={data.nrMaxPersoane} onChange={update("nrMaxPersoane")} placeholder="ex: 2" type="number" half />
      <div style={{ flex: "1 1 48%", minWidth: "220px" }}>
        <Toggle label="Mobilat si utilat" description="Imobilul este predat mobilat" checked={data.mobilat} onChange={toggleField("mobilat")} />
      </div>
    </div>
  );
}
